module.exports = __webpack_public_path__ + "img/cart-empty_@2x.f25b2c8c.png";